module.exports = __webpack_public_path__ + "img/kablosuzbeyin_500x.b05008ad.png";